module.exports = __webpack_public_path__ + "img/v3-table-view.bafb51b6.svg";